const techStack = [
  "HTML",
  "CSS",
  "JavaScript",
  "TypeScript",
  "React",
  "Webpack",
  "Vite",
  "API",
];

export default techStack;
